import React from "react";
import { Typography } from "@material-ui/core";
import { CalendarToday } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const GoogleCalendarSyncCard = ({ isSynced, onToggleSync }) => {
	const { t } = useTranslation();

	return (
		<div
			onClick={onToggleSync}
			style={{
				display: "flex",
				alignItems: "center",
				gap: 12,
				padding: "12px 16px",
				backgroundColor: isSynced ? "#E8F4E8" : "#fff",
				borderRadius: 12,
				border: "1px solid #EDEDE6",
				margin: "8px 16px 4px",
				cursor: "pointer",
			}}>
			<div style={{
				width: 36,
				height: 36,
				borderRadius: 8,
				backgroundColor: isSynced ? "#2B7A2B" : "#F0F0F0",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexShrink: 0,
			}}>
				<CalendarToday style={{ fontSize: 18, color: isSynced ? "#fff" : "#666" }} />
			</div>

			<div style={{ flex: 1 }}>
				<Typography style={{ fontSize: 13, fontWeight: 600, color: "#1A1A1A" }}>
					{t("Sync your schedules")}
				</Typography>
				<Typography style={{ fontSize: 12, color: "#888" }}>
					{t("directly in Google Calendar")}
				</Typography>
			</div>

			<Typography style={{
				fontSize: 13,
				fontWeight: 700,
				color: isSynced ? "#2B7A2B" : "#8B1538",
				flexShrink: 0,
			}}>
				{isSynced ? t("Synced") : t("Activate")}
			</Typography>
		</div>
	);
};

export default GoogleCalendarSyncCard;
